export const SEARCH_DELAY = 750;
export const DEFAULT_SEARCH_RADIUS = 15;
export const DEFAULT_SEARCH_RADIUS_DATO = "15000";
